import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import PageShell from '../components/ui/PageShell'
import Card from '../components/ui/Card'
import SectionTitle from '../components/ui/SectionTitle'

const linkClass = 'text-[#00d4aa] hover:underline'

export default function Impressum() {
  const location = useLocation()
  const isDashboard = location.pathname.startsWith('/dashboard')
  return (
    <PageShell>
      <div className="max-w-3xl space-y-6">
        <SectionTitle title="Impressum" />
        <Card className="p-6 space-y-6 text-sm text-white/90">
          <p className="text-white/70">Angaben gemäß §&nbsp;5 DDG (Digitale-Dienste-Gesetz)</p>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">Anbieter</h2>
            <p>
              <strong>Marc Fischer Digital Solution NRW</strong>
              <br />
              Einzelunternehmen
              <br />
              Inhaber: Marc Fischer
              <br />
              Lärchenweg 9
              <br />
              50389 Wesseling
              <br />
              Deutschland
            </p>
            <p className="mt-2 text-white/60">
              Dienst: AI Mastering Studio ·{' '}
              <a href="https://mastering.anwendungen.online" className={linkClass} target="_blank" rel="noopener noreferrer">
                mastering.anwendungen.online
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">Kontakt</h2>
            <p>
              Telefon:{' '}
              <a href="tel:+4922325509977" className={linkClass}>
                02232 / 5509977
              </a>
              <br />
              <span className="text-xs text-white/50">
                Die Rufnummer wird zunächst von einer KI entgegengenommen und bei Bedarf an einen Mitarbeiter weitergeleitet.
              </span>
              <br />
              E-Mail:{' '}
              <a href="mailto:kontakt@anwendungen.online" className={linkClass}>
                kontakt@anwendungen.online
              </a>
              <br />
              Website:{' '}
              <a href="https://digitalsolutionnrw.de" className={linkClass} target="_blank" rel="noopener noreferrer">
                https://digitalsolutionnrw.de
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">Umsatzsteuer</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß §&nbsp;27a Umsatzsteuergesetz:
              <br />
              <strong>DE325478997</strong>
            </p>
            <p className="mt-2">
              Steuernummer: <strong>219/5087/2865</strong>
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">Verantwortlich für den Inhalt nach §&nbsp;18 Abs.&nbsp;2 MStV</h2>
            <p>
              Marc Fischer
              <br />
              Lärchenweg 9
              <br />
              50389 Wesseling
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr/" className={linkClass} target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="mt-2">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">Verbraucherstreitbeilegung</h2>
            <p>
              Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß §&nbsp;7 Abs.&nbsp;1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen
              Gesetzen verantwortlich. Nach §§&nbsp;8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet,
              übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
              rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-2">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
              hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
              Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend
              entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können
              wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der
              jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
              Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
              bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

          <p className="text-white/50 pt-4 border-t border-white/10 text-xs">
            © {new Date().getFullYear()} Marc Fischer Digital Solution NRW · AI Mastering Studio (anwendungen.online)
          </p>
        </Card>
        <p className="text-center">
          <Link to={isDashboard ? '/dashboard' : '/'} className={linkClass}>
            ← {isDashboard ? 'Zum Dashboard' : 'Zur Startseite'}
          </Link>
        </p>
      </div>
    </PageShell>
  )
}
